<template>
  <div class="page-wrapper">
      <TopBarDetail
        :title="lbl.draw.page_title"
        type="list"
        @clickBack="clickBack()"
      >
      </TopBarDetail>
      <div id="reward_content" class="page-content">
          <div class="wrapper-campaign">
            <CampaignList
                :isLoading='isLoading'
                :initListConfig="listConfig"
            >

            </CampaignList>
          </div>
      </div>
      <ModalMaster :controller="modalController" />
  </div>
</template>

<script>
// config
import ConfigManager from '@/config/ConfigManager'
// core
import { CampaignListConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel'
// component
import CampaignList from '../component/CampaignList.vue'
import TopBarDetail from '@/components/Layout/TopBarPage/TopBarDetail.vue'
// mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'Luckydraw',
    mixins: [ModalMixin, LocaleMixin],
    components: {
        TopBarDetail,
        CampaignList,
    },
    data: function() {
        return {
            isLoading: false,
            listConfig: {},
        }
    },
    created: function() {
        this.initialConfig();
    },
    methods: {
        // initial
        initialConfig: function() {
            var configStr = ConfigManager.getCampaignLuckydraw();
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr)
                

            this.listConfig = listConfig.create();

        },
        clickBack: function() {
            this.$router.push('/home');
        },
        // utility
        showLoading: function() {
            setTimeout(() => {
                this.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
            if(this.isLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
    }
}
</script>

<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";

#reward_content {
    background-color: $deep-blue;
    padding: {
        top: $topbar-height;
    };
}

.wrapper-campaign {
    padding: 20px 25px 25px;
}
</style>